<template>
  <div class="market-wrap">
    <CoinToCoinAccountTitle
      :titles="[this.$t('labels.finance.coinToCoinAcc'), this.$t('labels.finance.transaction')]"
    ></CoinToCoinAccountTitle>

    <div class="form-wrap">
      <GForm :config="formConfig" :renderData="form" />
      <div class="filter-btn">
        <span @click="search()">{{ $t('labels.transaction.search') }}</span>
      </div>
    </div>

    <AllTxnTable
      :data="transactions.data"
      :coin-id.sync="coinId"
      :coin-list="Getter_Assets_List"
      :pagination-config.sync="transactions.query"
      :business-type="businessType_tableFilter"
      :business-sub-type="businessSubType_tableFilter"
    />
  </div>
</template>

<script>
import index from './transaction.js';
export default index;
</script>

<style lang="stylus" scoped>
.goggle-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
}
.goggle-wrap > div {
  flex: 0 1 50%;
  padding: 10px 30px;
  line-height: 40px;
  font-size: 16px;
  color: rgba(138, 144, 154, 1);
}
.financial-records-btn {
  cursor: pointer;
}
.financial-records-btn > span {
  position: relative;
  display: block;
}
.financial-records-btn > span.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 6px) rotate(45deg);
  border-top: 1px solid rgba(230, 234, 240, 1);
  border-left: 1px solid rgba(230, 234, 240, 1);
  background-color: #fff;
  width: 10px;
  height: 10px;
}
.market-forms {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
}
.market-forms input {
  border: 1px solid rgba(230, 234, 240, 1);
  border-radius: 2px;
  padding: 0 10px;
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  color: #333;
}
.market-content {
  margin-top: 40px;
}
.market-wrap {
  margin: 0 auto;
  padding: 0 10px;
  max-width: 1400px;
  // padding-bottom: 100px;
  min-height: 50vh;
}
.market-tab {
  display: flex;
  background-color: #fff;
  border: 1px solid rgba(230, 234, 240, 1);
}
.market-tab > li {
  padding: 0 20px;
  font-size: 16px;
  font-weight: bold;
  line-height: 70px;
  color: #666;
  cursor: pointer;
}
.market-tab > li.active {
  color: #000000;
}
.delete-btn:hover::v-deep .q-focus-helper {
  background: none !important;
}
.filter-btn {
  display: flex;
  justify-content: flex-start;
}
.filter-btn > span {
  cursor: pointer;
  display: flex;
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  background: rgba(77, 103, 178, 1);
  border-radius: 2px;
  color: #fff;
  font-size: 14px;
  margin: 20px 10px 10px 10px;
}
@media screen and (max-width: 599px) {
  .market-wrap::v-deep .market-title {
    font-size: 0.85rem;
  }
}
</style>
